module.exports = __webpack_public_path__ + "static/media/payment-page-sc.f2f8dcf8.png";